import { Loading } from "element-ui"
import NProgress from "nprogress" // progress bar
import "nprogress/nprogress.css" // progress bar style
import router from "@/router"
import store from "@/store"
import { getToken } from "@/utils/auth" // get token from cookie
import getPageTitle from "@/utils/get-page-title"
import defaultSettings from "@/settings"

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ["/login", "/auth-redirect"] // no redirect whitelist

// 显示加载
let loadingInstance

router.beforeEach(async (to, from, next) => {
  // 显示加载框
  if (defaultSettings.showLoading) {
    loadingInstance = Loading.service({
      fullscreen: true,
      text: "加载中...",
    })
  }

  // start progress bar
  NProgress.start()

  // set page title
  const embedSearchType = Number(to.query && to.query.search_type)
  const pageTitle =
    to.name === "ai-search-embed" && embedSearchType === 1
      ? "AI推荐结果"
      : to.meta.title
  document.title = getPageTitle(pageTitle)

  // 公开路由（如 iframe 嵌入页）不依赖主站 Cookie 和用户信息
  if (to.matched.some((route) => route.meta && route.meta.public)) {
    next()
    return
  }

  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === "/login") {
      // if is logged in, redirect to the home page
      next({ path: "/" })
      NProgress.done()
    } else {
      await store.dispatch("user/getInfo");
      next()
    }
  } else {
    /* has no token */
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else if (to.path !== "/") {
      // other pages that do not have permission to access are redirected to the login page.
      next({ path: "/" })
      NProgress.done()
    } else {
      next()
    }
  }
})

router.afterEach(() => {
  setTimeout(() => {
    if (loadingInstance) {
      loadingInstance.close()
    }
  }, 500)

  // finish progress bar
  NProgress.done()
})
